var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFollower(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_368_8500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6623 13.9944V12.6616C10.6623 11.9547 10.3815 11.2767 9.8816 10.7768C9.38172 10.2769 8.70374 9.99609 7.9968 9.99609H3.99852C3.29159 9.99609 2.6136 10.2769 2.11372 10.7768C1.61384 11.2767 1.33301 11.9547 1.33301 12.6616V13.9944",
    stroke: "#6A7282",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99755 7.33103C7.46967 7.33103 8.66306 6.13764 8.66306 4.66552C8.66306 3.19339 7.46967 2 5.99755 2C4.52542 2 3.33203 3.19339 3.33203 4.66552C3.33203 6.13764 4.52542 7.33103 5.99755 7.33103Z",
    stroke: "#6A7282",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6603 13.9937V12.6609C14.6598 12.0703 14.4633 11.4966 14.1014 11.0298C13.7396 10.5631 13.233 10.2297 12.6611 10.082",
    stroke: "#6A7282",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6621 2.08594C11.2355 2.23274 11.7437 2.5662 12.1066 3.03374C12.4695 3.50127 12.6665 4.0763 12.6665 4.66816C12.6665 5.26001 12.4695 5.83504 12.1066 6.30258C11.7437 6.77012 11.2355 7.10357 10.6621 7.25038",
    stroke: "#6A7282",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_368_8500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9931,
    height: 15.9931,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollower);
export default __webpack_public_path__ + "static/media/follower.5c064de51096a35add2f7339156ae2d8.svg";
export { ForwardRef as ReactComponent };